import { useQuestCompletions } from "@/components/QuestsV2/useQuestCompletions";
import { IMMUTABLE_GAME_ID, ONBOARDING_QUEST_ID } from "@/constants";
import { usePassportProvider } from "@/context";
import { useEffect, useMemo } from "react";
import { useFeatureFlags } from "./useFeatureFlags";

export const useIsActivationEligible = () => {
  const { activationPanel } = useFeatureFlags();
  const { isLoggedIn, isInitializing } = usePassportProvider();
  const { completedQuests, isLoading, mutate } =
    useQuestCompletions(IMMUTABLE_GAME_ID);

  useEffect(() => {
    if (isLoggedIn && !isInitializing) mutate();
  }, [isLoggedIn, isInitializing, mutate]);

  const activationEligible = useMemo(() => {
    if (!activationPanel || isLoading || !completedQuests) return false;

    const onboardingQuestCompletionTime =
      completedQuests?.[ONBOARDING_QUEST_ID.replace("-event", "")]
        ?.latest_completion_time;

    if (
      onboardingQuestCompletionTime &&
      new Date(onboardingQuestCompletionTime).getTime() >
        // Activation eligible if onboarding completed less than 48 hours ago
        Date.now() - 2 * 24 * 60 * 60 * 1000
    ) {
      return true;
    }

    return false;
  }, [completedQuests, activationPanel, isLoading]);

  return { activationEligible, isLoading, activationPanel };
};
